import config from 'src/config'

/**
 * Sendet einen GET-Request an den Server.
 * 
 * @returns Antwort als Javascript-Objekt
 */
export interface getOptions {
  url: string
  signal?: AbortSignal
  local?: boolean
  headers?: Record<string, string>
}
export const get = async ({ 
  url, signal, local, headers = {},
}:getOptions):Promise<unknown> => {

  const res = await fetch(
    `${config.api_server[local ? 'local' : 'online']}/${url}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', ...headers },
      signal,
    }
  )
  .then(res => res.json())
  .catch(e => { handleError(e); return null })

  return res
}

/**
 * Sendet einen POST-Request an den Server.
 * 
 * @returns Antwort als Javascript-Objekt
 */
export interface postOptions extends getOptions {
  body: unknown
}
export const post = async ({ 
  url, body, signal, local, headers = {},
}:postOptions):Promise<unknown> => {

  const res = await fetch(
    `${config.api_server[local ? 'local' : 'online']}/${url}`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json', ...headers },
      signal,
    }
  )
  .then(res => res.json())
  .catch(e => { handleError(e); return null })

  return res
}

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

const handleError = (err:Error) => {
  if (err.name === 'AbortError') {
    //console.info('Request aborted')
    return
  }
  const cause = (err as Error & { cause?: { code?: string; errno?: number } }).cause
  const suffix = cause?.code ? ` (${cause.code})` : ''
  console.error(`${err.name}: ${err.message}${suffix}`)
}

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
